import VariablesList from "./VariablesList";

export default VariablesList;
